module.exports = __webpack_public_path__ + "img/450a.0ae9a2f6.png";